// extracted by mini-css-extract-plugin
export default {"container":"style_container__nD88a","circle":"style_circle__r5tzY","question":"style_question__k4qQz","modal":"style_modal__BDxDH"};